export const TEAM_NAME = 'jira-yurree';
export const PACKAGE_NAME = '@atlassian/jira-hover-popover';
